import AxiosClient from "../../../services/axios.services";

class ScheduleTrackingPlannedVacationsEmployeeServices {
  getScheduleTrackingPlannedVacationsEmployees = params =>
    AxiosClient.post("/api/app/Tiempos_empleado_agenda_tablero/", params);
}

export default new ScheduleTrackingPlannedVacationsEmployeeServices();